import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';
import { history } from "../../store/configure-store";

const Div = styled.div`
  background-color: ${({ theme }) => theme.colors.primary };
  color: white;
  cursor: pointer;
  display: block;
  font-family: Alegreya, serif;
  font-size: 22px;
  height: 50px;
  left: calc(50vw - 100px);
  padding: 10px;
  position: fixed;
  top: calc(100vh);
  text-align: center;
  transition: transform 1s;
  transform: translateZ(0);
  transform-origin: bottom center;
  width: 200px;
  z-index: 10000;

  &.is-active {
    transform: translate3d(0, -50px, 0);
    
    //@media (min-aspect-ratio: 16/12) {
    //  transform: translate3d(0, -150px, 0);
    //}
    
    @media (max-width: 415px) {
      transform: translate3d(0, -165px, 0);
      opacity: .90;
    }

    @media (max-width: 380px) {
      transform: translate3d(0, -125px, 0);
      opacity: .90;
    }
  }
`;

const ShowMeMore = ({ currentSlide, handleClick, totalSlides, folioNavigationEnabled }) => {
  const styles = [
    {
      'is-active': currentSlide - 1 === totalSlides,
      'more': true
    }];

  return (
      <Div onClick={ () => { handleClick(); history.push('/folio') } }
           className={ classnames(styles) }>
        Show me more
      </Div>
  );
};

ShowMeMore.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  toggleFolioNav: PropTypes.func,
  totalSlides: PropTypes.number
};

export default ShowMeMore



// WEBPACK FOOTER //
// ./src/components/ShowMeMore/index.js